export default "__VITE_ASSET__BRd2GA79__"